<template>
  <div class="text-center dark my-2">
    <b-spinner class="align-middle mr-2"></b-spinner>
    <strong> {{ $t('components.doinsport.table.loading') }} ...</strong>
  </div>
</template>
<script>
export default {}
</script>